<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-button type="default" @click="toDetail(null)">新建运费模版</el-button>
      </el-col>
      <el-col :span="12" class="text-right">
        <el-input
          class="search-input"
          placeholder="输入模版名称搜索"
          v-model="templateName"
          clearable
        ></el-input>
        <el-button type="primary" @click="search">搜索</el-button>
      </el-col>
    </el-row>
    <div class="table">
      <el-table :data="list">
        <el-table-column>
          <template slot-scope="scope">
            <span class="link-text" @click="toDetail(scope.row.id)">{{
              scope.row.templateName
            }}</span>
            <span v-if="scope.row.countItem" class="c-9">
              （已被
              <router-link
                :to="{
                  name: 'goodsList',
                  query: { transportTemplateId: scope.row.id, type: 'refresh' }
                }"
                >{{ scope.row.countItem }}</router-link
              >个商品使用）
            </span>
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template slot-scope="scope">
            <span class="m-r10"
              >最后编辑时间：{{ scope.row.gmtModified | parseTime('{y}-{M}-{d}') }}</span
            >
            <el-button class="m-r10" type="text" @click="copy(scope.row.id)">复制</el-button>
            <el-button class="m-r10" type="text" @click="toDetail(scope.row.id)">编辑</el-button>
            <el-button type="text" @click="del(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="text-right">
      <el-pagination
        layout="total, prev, pager, next, jumper"
        :page-size="query.pageSize"
        :current-page="query.pageNo"
        :total="totalCount"
        @current-change="getList"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FreightTempleteList',
  data() {
    return {
      query: {
        templateName: '',
        pageNo: 1,
        pageSize: 10
      },
      totalCount: 1,
      list: [],
      templateName: ''
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList(pageNo) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      const res = await this.$get('lgcenter.getLgFreightTemplateList', {
        param: this.query
      })
      const { success, data } = res
      if (success && data && data[0]) {
        this.list = data[0].data
        this.totalCount = data[0].totalCount
      }
    },
    async copy(id) {
      const res = await this.$post('lgcenter.copyLgFreightTemplateById', {
        lgFreightTemplateId: id
      })
      const { success, data, totalCount } = res
      if (success) {
        this.getList(1)
      }
    },
    async del(id) {
      const res = await this.$post('lgcenter.delLgFreightTemplate', {
        lgFreightTemplateId: id
      })
      const { success, data, totalCount } = res
      if (success) {
        this.getList()
      }
    },
    search() {
      this.query.templateName = this.templateName
      this.getList(1)
    },
    toDetail(id) {
      let route = {
        name: 'freightTempleteDetail'
      }
      if (id) {
        route['query'] = {
          id
        }
      }
      this.$router.push(route)
    }
  }
}
</script>

<style lang="less" scoped>
.table {
  min-height: 700px;
}
.search-input {
  width: 235px;
}
</style>
